import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { green, grey, white } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui */
const menuTokens = [
  { propertyPath: 'background', tokenName: '--semantic-bg-surface-floating' },
  { propertyPath: 'item.hover', tokenName: '--bg-hover' },
  { propertyPath: 'item.selected', tokenName: '--bg-active' },
] satisfies Token[];

export const menuTokenMetadata: PaletteTokenMetadata = {
  componentName: 'menu',
  tokens: menuTokens,
};

export const menu = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['menu'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(menuTokenMetadata.tokens, tokens, xcorTokens);
  }

  // Legacy values matching what was previously in background.default and action.menuHover/menuSelected
  return mode === 'light'
    ? {
        background: white,
        item: {
          hover: 'rgba(164, 172, 200, 0.2)', // alpha(grey[300], 0.2)
          selected: green[50],
        },
      }
    : {
        background: grey[900],
        item: {
          hover: 'rgba(164, 172, 200, 0.2)', // alpha(grey[300], 0.2)
          selected: green[800],
        },
      };
};
